"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = priceChangedSuccess;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _transform = _interopRequireDefault(require("lodash/transform"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function priceChangedSuccess(state, _ref) {
  var choiceDeltas = _ref.choiceDeltas;
  return (0, _transform["default"])(state, function (newState, choice, choiceId) {
    var matchingPrice = choiceDeltas[choice.id];
    if (matchingPrice) {
      // eslint-disable-next-line no-param-reassign
      newState[choiceId] = _objectSpread(_objectSpread({}, choice), {}, {
        price: matchingPrice.delta.toFixed(2),
        originalPrice: matchingPrice.originalPrice ? matchingPrice.originalPrice.toFixed(2) : '',
        activatesPromo: matchingPrice.activatesPromo,
        priceDelta: matchingPrice.priceDelta
      });
    } else {
      // eslint-disable-next-line no-param-reassign
      newState[choiceId] = _objectSpread(_objectSpread({}, choice), {}, {
        price: '0.00',
        originalPrice: '0.00',
        priceDelta: 0
      });
    }
  }, _objectSpread({}, state));
}
//# sourceMappingURL=priceChangedSuccess.js.map